import { useMemo } from 'react';

import { mergeDefaultAndCommonFindings } from '../util';
import { useFindingsByOrgan } from './use-findings-by-organ.hook';

export function useDefaultAndCommonFindings() {
  const { defaultFindings, findings } = useFindingsByOrgan();

  const value = useMemo(
    () => mergeDefaultAndCommonFindings(defaultFindings, findings),
    [defaultFindings, findings],
  );

  return value;
}
